import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import {homeServices} from '../data';
import Card from '../UI/Card';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import '../pages/home/home.css';

const HomeServicesCarousel = () => {
    const settings = {
        dots: true,
        autoplay: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        speed: 500,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1
                }
            }
        ]
    };
    return (
        <>
            <Slider {...settings}>
                    {
                        homeServices.map(({id, title, description, img, path}) => {
                            return(
                                <Card key={id} className="home_services_carousel_items">
                                    <img src={img} alt="sevices image" />
                                    <div className="home_services_details">
                                        <h3>{title}</h3>
                                        <p>{description}</p>
                                        <Link to={path} className='home_services_btn  btn sm'>Learn More</Link>
                                    </div>
                                </Card>       
                            )
                        })
                    }
            </Slider>
        </>
    )
}

export default HomeServicesCarousel